// Registro de resultados POR CONTEXTO da lista de conversas.
//
// Contexto = assinatura (aba | status | caixa | etiqueta | time | tipo |
// ordenacao | flags). Cada contexto guarda a ORDEM que o servidor devolveu
// (ids), o cursor da ultima pagina e se o fim foi atingido. O cliente nunca
// mais decide associacao/ordem de uma visao: o servidor manda, aqui so
// registra. Os dados das conversas seguem no cache compartilhado
// (allConversations), que vira um mapa de leitura por id.
const state = {
  contexts: {},
};

const VAZIO = Object.freeze({
  ids: [],
  cursor: null,
  endReached: false,
  pagina: 0,
});

export const getters = {
  getContext: $state => chave => $state.contexts[chave] || VAZIO,
};

const sincronizarProtegidos = (commit, ctxState) => {
  const ids = new Set();
  Object.values(ctxState.contexts).forEach(ctx =>
    (ctx.ids || []).forEach(id => ids.add(id))
  );
  commit('SET_PROTECTED_CONVERSATION_IDS', Array.from(ids), { root: true });
};

export const actions = {
  upsertPage({ commit, state: $state }, payload) {
    commit('UPSERT_RESULT_PAGE', payload);
    sincronizarProtegidos(commit, $state);
  },
  // Atividade ao vivo: move (ou insere) a conversa no TOPO do contexto —
  // espelho local do que o servidor faria na proxima pagina 1 com
  // last_activity_at desc. Sem isso a ordem ficava congelada entre fetches
  // e "conversa recente nao sobe" (regressao da saga da paginacao).
  promoteToHead({ commit, state: $state }, payload) {
    const jaListada = ($state.contexts[payload.chave]?.ids || []).includes(
      payload.id
    );
    commit('PROMOTE_RESULT_TO_HEAD', payload);
    if (!jaListada) sincronizarProtegidos(commit, $state);
  },
  resetContext({ commit, state: $state }, chave) {
    commit('RESET_RESULT_CONTEXT', chave);
    sincronizarProtegidos(commit, $state);
  },
};

export const mutations = {
  UPSERT_RESULT_PAGE(
    $state,
    { chave, ids, cursor, fim, substituirCabeca, pagina }
  ) {
    const atual = $state.contexts[chave] || { ...VAZIO, ids: [] };
    let novosIds;
    if (substituirCabeca) {
      // refresh da cabeca: pagina 1 nova na frente, cauda ja carregada
      // preservada (sem duplicar)
      const recebidos = new Set(ids);
      novosIds = [...ids, ...atual.ids.filter(id => !recebidos.has(id))];
    } else {
      const existentes = new Set(atual.ids);
      novosIds = [...atual.ids, ...ids.filter(id => !existentes.has(id))];
    }
    $state.contexts = {
      ...$state.contexts,
      [chave]: {
        ids: novosIds,
        // cursor so avanca em append; refresh de cabeca nao mexe na cauda
        cursor: substituirCabeca
          ? atual.cursor || cursor
          : cursor || atual.cursor,
        endReached: substituirCabeca ? atual.endReached : fim,
        pagina: substituirCabeca ? Math.max(atual.pagina, 1) : pagina,
      },
    };
  },
  PROMOTE_RESULT_TO_HEAD($state, { chave, id }) {
    const atual = $state.contexts[chave] || { ...VAZIO, ids: [] };
    if (atual.ids[0] === id) return;
    $state.contexts = {
      ...$state.contexts,
      [chave]: {
        ...atual,
        ids: [id, ...atual.ids.filter(x => x !== id)],
      },
    };
  },
  RESET_RESULT_CONTEXT($state, chave) {
    const { [chave]: _fora, ...resto } = $state.contexts;
    $state.contexts = resto;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
